import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` that fallbacks to `useEffect` on server side
 * rendering.
 */
var useIsomorphicEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

export default useIsomorphicEffect;
//# sourceMappingURL=use-isomorphic-effect.esm.js.map
